import { TRANSACTION_SUB_TYPES, TRANSACTION_TYPES } from "Views/Transaction/Constants";

export const includesReversalTrxns = (type: string) =>
  type?.includes(TRANSACTION_SUB_TYPES.REVERSAL) || type?.includes(TRANSACTION_TYPES.FEES_REFUND);
